import { render } from "./ExpectedDispatchManifestShipmentTable.vue?vue&type=template&id=778990b9&scoped=true"
import script from "./ExpectedDispatchManifestShipmentTable.vue?vue&type=script&lang=js"
export * from "./ExpectedDispatchManifestShipmentTable.vue?vue&type=script&lang=js"

import "./ExpectedDispatchManifestShipmentTable.vue?vue&type=style&index=0&id=778990b9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778990b9"]])

export default __exports__